import styled from 'styled-components';

export const SiteHeader = styled.div`
  height: 68px;
  @media only screen and (max-width: ${({ theme }) =>
      theme.screen.size.small}px) {
    height: auto;
  }
`;
